export default __webpack_public_path__ + "static/media/pink-ball.6acbfd8e.svg";